export const constants = {
  SELECT_LOCATION: 'SELECT_LOCATION',
  AGREE_TO_TERMS: 'AGREE_TO_TERMS',
  EDIT_API_FIELDS: 'EDIT_API_FIELDS',
  PRIVACY_PROTECTION: 'PRIVACY_PROTECTION',
  DMS_SELECTION: 'DMS_SELECTION',
  REVIEW_SUBSCRIPTION: 'REVIEW_SUBSCRIPTION',
  COMPLETE_CONFIGURATION: 'COMPLETE_CONFIGURATION',
  API_SUBSCRIPTION_SETTINGS: 'API_SUBSCRIPTION_SETTINGS'
}

export const hideStep = (hideEditAPIField, hideCPP, hideDMS, hideConfig, hideManageApiSubscriptionSettings) => {
  let bodyConfig = {
    1: constants.SELECT_LOCATION,
    2: constants.AGREE_TO_TERMS
  };
  let nextStep = 3;

  if (!hideManageApiSubscriptionSettings) {
    bodyConfig[nextStep] = constants.API_SUBSCRIPTION_SETTINGS;
    nextStep++;
  }
  
  if(!hideEditAPIField) {
    bodyConfig[nextStep] = constants.EDIT_API_FIELDS;
    nextStep++;
  }

  if (!hideCPP) {
    bodyConfig[nextStep] = constants.PRIVACY_PROTECTION;
    nextStep++;
  }
  if (!hideDMS) {
    bodyConfig[nextStep] = constants.DMS_SELECTION;
    nextStep++;
  }

  bodyConfig[nextStep] = constants.REVIEW_SUBSCRIPTION;
  nextStep++;

  if (!hideConfig) {
    bodyConfig[nextStep] = constants.COMPLETE_CONFIGURATION;
  }

  return bodyConfig;
}
